import React from "react";
import { Sidebar } from "primereact/sidebar";
import { ProgressSpinner } from "primereact/progressspinner";
import "./Style.css";

export default function SliderBar({ visible, onHide, uploadingFiles }) {
  const onhidden = () => {
    onHide();
  };

  const CurentAccCode = localStorage.getItem("AccountGroupCode");
  const Val = localStorage.getItem("Value");

  return (
    <div className="card flex justify-content-center">
      <Sidebar
        visible={visible}
        position="left"
        onHide={onhidden}
        className="custom-sidebar"
      >
        {/* Container for spinner and file list */}
        <div className="upload-container">
          {/* Render uploaded file list or default message */}
          {CurentAccCode && Val == "true" ? (
            <ul className="file-list">
              {uploadingFiles && uploadingFiles.length > 0 ? (
                uploadingFiles.map((file, index) => (
                  <li key={index} className="file-item">
                    <ProgressSpinner
                      style={{ width: "20px", height: "20px" }} // Smaller size
                      strokeWidth="6" // Thinner spinner
                      animationDuration=".5s" // Continuous rotation
                      className="spinner"
                    />
                    <span
                      className="file-name"
                      title={file}
                      style={{ cursor: "pointer" }}
                    >
                      {file}
                    </span>
                  </li>
                ))
              ) : (
                <li>No files are currently being uploaded.</li>
              )}
            </ul>
          ) : (
            <div style={{ marginTop: "70px" }}>
              No files are currently being uploaded.
            </div>
          )}
        </div>
      </Sidebar>
    </div>
  );
}
